<template>
	<div class="dropdown"
		tabindex="0"
		@blur="close"
		@keyup.up.prevent="scroll(1)"
		@keyup.down.prevent="scroll(-1)"
		@keyup.enter.prevent="choose(options[hovered], hovered)"
		@focus="openOptions">
		<div
			class="dropdown__select"
			@click="openOptions"
			:class="{'dropdown__select--placeholder':!valueSet, 'dropdown__select--faint':faint}"
			ref="select">
			{{display}}
		</div>
		<div
			:style="{
				'width': width,
				'top': top
			}"
			ref="options"
			v-click-outside="close"
			v-if="open"
			class="dropdown__options">
			<div
				class="dropdown__option"
				:class="{'dropdown__option--selected':selected(option), 'dropdown__option--hovered':index === hovered}"
				:value="option"
				:key="index"
				v-for="(option, index) in options"
				@click="choose(option, index)">
				{{getLabel(option)}}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		faint: Boolean,
		typable: Boolean,
		placeholder: String,
		options: Array,
		labels: Array,
		value: null
	},
	data () {
		return {
			open: false,
			top: 0,
			width: 0,
			hovered: -1
		}
	},
	methods: {
		openOptions () {
			this.open = true
			this.setOffset()
		},
		setOffset () {
			const select = this.$refs.select
			this.width = select.clientWidth + 'px'
			let coords = select.getBoundingClientRect()
			this.top = coords.bottom + 'px'
		},
		close () {
			if (event.target !== this.$refs.select) this.open = false
		},
		choose (option, index) {
			if (!this.open) return
			this.$emit('input', option)
			this.$emit('change')
			this.open = false
			this.hovered = index
		},
		selected (option) {
			if (!this.valueSet) return false
			return option === this.value
		},
		getLabel (unlabeledOption) {
			const selectedIndex = this.options.findIndex(option => option === unlabeledOption)
			return this.labels[selectedIndex]
		},
		scroll (direction) {
			if (this.open) {
				if (direction === -1) {
					// Scroll down
					if (this.hovered === this.options.length - 1) return
					this.hovered++
				} else if (direction === 1) {
					// Scroll up
					if (this.hovered < 1) return
					this.hovered--
				}
			}
			this.openOptions()
		}
	},
	computed: {
		display () {
			// If no value is selected, revert to placeholder
			if (!this.valueSet) return this.placeholder
			// Find the corresponding option and returns it display
			const selectedIndex = this.options.findIndex(option => option === this.value)
			return this.labels[selectedIndex]
		},
		valueSet () {
			if (!this.value && this.value !== 0) return false
			return true
		}
	},
	watch: {
		value () {
			if (!this.valueSet) this.hovered = -1
		}
	},
	created () {
		if (!this.valueSet) return -1
		// Find the corresponding option and returns it display
		const selectedIndex = this.options.findIndex(option => option === this.value)
		this.hovered = selectedIndex
	},
	beforeMount () {
		document.addEventListener('scroll', this.setOffset, true)
	},
	beforeDestroy () {
		document.removeEventListener('scroll', this.setOffset, true)
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_dropdown.scss";
</style>
